import { delay } from '../utils/delay.mjs';
function createInstantAnimation(_ref) {
  let {
    keyframes,
    elapsed,
    onUpdate,
    onComplete
  } = _ref;
  const setValue = () => {
    onUpdate && onUpdate(keyframes[keyframes.length - 1]);
    onComplete && onComplete();
    return () => {};
  };
  return elapsed ? delay(setValue, -elapsed) : setValue();
}
export { createInstantAnimation };